import { z } from 'zod';

export const AcademicYearSchema = z.object({
  id: z.string(),
  year: z.number().int(),
  label: z.string(),
  startDate: z.string(),
  endDate: z.string(),
  current: z.boolean(),
  status: z.enum(['ACTIVE', 'CLOSED']),
});
export type AcademicYear = z.infer<typeof AcademicYearSchema>;

export const TermSchema = z.object({
  id: z.string(),
  academicYearId: z.string(),
  name: z.string(),
  number: z.number().int(),
  startDate: z.string(),
  endDate: z.string(),
});
export type Term = z.infer<typeof TermSchema>;

export const SubjectSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  active: z.boolean(),
});
export type Subject = z.infer<typeof SubjectSchema>;

export const AcademicContextSchema = z.object({
  academicYears: z.array(AcademicYearSchema),
  currentAcademicYearId: z.string().nullable(),
  terms: z.array(TermSchema),
  currentTermId: z.string().nullable(),
  subjects: z.array(SubjectSchema),
  grades: z.array(z.string()),
});
export type AcademicContext = z.infer<typeof AcademicContextSchema>;

export const TeacherSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string().nullable(),
  photoUrl: z.string().nullable(),
  /** Nomes das disciplinas. */
  subjects: z.array(z.string()),
  subjectIds: z.array(z.string()),
  active: z.boolean(),
});
export type Teacher = z.infer<typeof TeacherSchema>;
